import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';

@Injectable()
export class NotificationsService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public getAllUserNotifications(params?: any): Observable<any> {
    const queryParams = params || { limit: 100, page: 0 };
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/all`,{params: queryParams}
    );
  }
}
